module.exports = __webpack_public_path__ + "static/media/ba.71010dff.svg";